import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { GET_METHOD_ASSOC_LEVELS } from "./types";


export const getMethodAssocLevels = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/method_assoc_levels`);
    dispatch({ type: GET_METHOD_ASSOC_LEVELS, payload: data });
  } catch (ERR) {
  }
};

export const updateMethodAssocLevels = (params) => async (dispatch) => {
  try {
    await api.put(`/method_assoc_levels/${params.malid}`, params);
    await dispatch(getMethodAssocLevels());
    createNotification('success', 'Успешно');
  } catch (error) {
    createNotification('error', "Не удалось обновить запись");
  }
};

export const createMethodAssocLevels = (data) => async (dispatch) => {
  try {
    await api.post(`/method_assoc_levels`, data);
    await dispatch(getMethodAssocLevels());
    createNotification('success', 'Успешно');
  } catch (error) {
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteMethodAssocLevels = (id) => async (dispatch) => {
  try {
    await api.delete(`/method_assoc_levels/${id}`);
    await dispatch(getMethodAssocLevels());
    createNotification('success', 'Успешно');
  } catch (error) {
    createNotification('error', "Не удалось удалить запись");
  }
};
